var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#B2D4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 4.16699L5.33398 5.91699V9.46949C5.33398 12.4153 7.32315 15.1628 10.0007 15.8337C12.6782 15.1628 14.6673 12.4153 14.6673 9.46949V5.91699L10.0007 4.16699ZM13.5007 9.46949C13.5007 11.8028 12.0132 13.9612 10.0007 14.6203C7.98815 13.9612 6.50065 11.8087 6.50065 9.46949V6.68116L10.0007 5.44449L13.5007 6.68116V9.46949ZM8.14565 9.17783L7.31732 10.0003L9.38232 12.0653L12.684 8.76366L11.8615 7.94116L9.38815 10.4145L8.14565 9.17783Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuard);
export default __webpack_public_path__ + "static/media/guard.28a18120fa115929c10bc8893aeb43f6.svg";
export { ForwardRef as ReactComponent };